import { RouteProps } from "react-router";
import NavigationServiceBase from "./NavigationServiceBase";
import { LocationState } from "history";
import { BaseService } from "./Service";

export interface WebRegisterRouteOptions {
	mainRouter?: RouteProps;
	myDLD?: RouteProps;
}

export interface NativeRegisterRouteOptions {

}

export interface WebNavigateOptions {
	query?: string;
	state?: LocationState;
}

export interface NativeNavigateOptions {

}

export type RegisterRouteOptions = WebRegisterRouteOptions | NativeRegisterRouteOptions;
export type NavigateOptions = WebNavigateOptions | NativeNavigateOptions;

export interface NavigationService extends BaseService {
	registerRoute: ( options: RegisterRouteOptions ) => void;
	navigate: ( path: string, options?: NavigateOptions ) => void;
	replaceNavigate: ( path: string, options?: NavigateOptions ) => void;
}


class NavigationServiceImpl extends NavigationServiceBase {
	readonly routes: RegisterRouteOptions[] = [];

	registerRoute( options: RegisterRouteOptions ): void {
		this.routes.push( options );
	}

}

const navigationService = new NavigationServiceImpl();
export default navigationService;
